module.exports = __webpack_public_path__ + "assets/assignment-skill-inactive.8c4ae6c7.svg";